import React from 'react'
import * as R from 'ramda'

import { Action } from './common/Action/Action'
import { Anchor } from './common/Anchor/Anchor'
import { Menu } from './common/Menu/Menu'
import { MenuItem } from './common/MenuItem/MenuItem'

import { useFloatingElement, useOnClickOutside } from 'hooks'
import { mergeRefs } from 'utils/refs'
import { DropdownHandlersContext, DropdownPropsContext } from './context'

export { DropdownHandlersContext, DropdownPropsContext }

export const Dropdown = ({
  children,
  initialPlacement,
  offsetSize,
  hasArrow = false,
  isInitiallyToggled = false,
}) => {
  const [isToggled, setIsToggled] = React.useState(isInitiallyToggled)

  const floatingRef = React.useRef(null)

  const {
    arrowRef,
    arrowStyle,
    floating,
    floatingStyle,
    middlewareData,
    reference,
  } = useFloatingElement({ initialPlacement, offsetSize, hasArrow })

  const handleDismiss = React.useCallback(() => {
    setIsToggled(false)
  }, [setIsToggled])

  const handleToggle = React.useCallback(
    event => {
      event.stopPropagation()
      event.preventDefault()

      setIsToggled(R.not)
    },
    [setIsToggled],
  )

  const propsContext = React.useMemo(
    () => ({
      arrowRef,
      arrowStyle,
      floating: mergeRefs([floatingRef, floating]),
      floatingStyle,
      middlewareData,
      reference,
      hasArrow,
      isToggled,
    }),
    [
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      middlewareData,
      reference,
      hasArrow,
      isToggled,
    ],
  )

  const handlersContext = React.useMemo(
    () => ({
      onDismiss: handleDismiss,
      onToggle: handleToggle,
    }),
    [handleDismiss, handleToggle],
  )

  useOnClickOutside(floatingRef, handleToggle)

  return (
    <DropdownPropsContext.Provider value={propsContext}>
      <DropdownHandlersContext.Provider value={handlersContext}>
        {children}
      </DropdownHandlersContext.Provider>
    </DropdownPropsContext.Provider>
  )
}

Dropdown.Action = Action
Dropdown.Anchor = Anchor
Dropdown.Menu = Menu
Dropdown.MenuItem = MenuItem
